let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9XtFm")).then(() => parcelRequire('bqPNv'));